module.exports = __webpack_public_path__ + "static/media/21_theworld.5581a9a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/21_theworld.png
// module id = 84
// module chunks = 0